import { CovDialog, CovTag } from "@cx-component-library/react-components";
import { Typography } from "@mui/material";
import type React from "react";
import "./ImageCarouselDialog.css";

interface ImageCarouselDialogProps {
  open: boolean;
  onClose: () => void;
  image?: string;
  label?: string;
  title?: string;
  textMore?: string;
  bgColor?: string;
}

export const ImageCarouselDialog: React.FC<ImageCarouselDialogProps> = ({
  open,
  onClose,
  image,
  label,
  title,
  textMore,
  bgColor,
}) => {
  return (
    <CovDialog
      className="image-carousel-dialog"
      open={open}
      onClose={onClose}
      bannerContent={
        <img
          src={image}
          alt={label}
          className="image-carousel-dialog__banner"
        />
      }
      dialogContent={
        <>
          <CovTag
            label={label}
            className="image-carousel-dialog__tag"
            style={{ backgroundColor: bgColor }}
          />
          <Typography className="image-carousel-dialog__title">
            {title}
          </Typography>
          <Typography className="image-carousel-dialog__content">
            <div dangerouslySetInnerHTML={{ __html: textMore ?? "" }}></div>
          </Typography>
        </>
      }
    />
  );
};
